var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "in-out-mail-wrapper" },
    [
      _c(
        "el-row",
        { staticClass: "btn-group" },
        [
          _c(
            "el-dropdown",
            {
              staticClass: "btn-item",
              attrs: { trigger: "click" },
              on: {
                command: function (val) {
                  return _vm.handleCommand(val, "tag")
                },
              },
            },
            [
              _c("el-button", { attrs: { type: "default", size: "medium" } }, [
                _vm._v(
                  " " +
                    _vm._s(_vm.$t("after-sales::in-box::in_out_mail_mark")) +
                    " "
                ),
                _c("i", { staticClass: "el-icon-arrow-down el-icon--right" }),
              ]),
              _c(
                "el-dropdown-menu",
                {
                  attrs: { slot: "dropdown", appendToBody: false },
                  slot: "dropdown",
                },
                _vm._l(_vm.tagList, function (item, i) {
                  return _c(
                    "el-dropdown-item",
                    { key: i, attrs: { command: item.value } },
                    [
                      _c("span", {
                        style:
                          "margin-right:4px;border-radius: 2px;display:inline-block;width:10px;height: 8px;vertical-align: middle;background: " +
                          item.color,
                      }),
                      _vm._v(" " + _vm._s(item.label) + " "),
                    ]
                  )
                }),
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("z-table", {
        directives: [
          {
            name: "loading",
            rawName: "v-loading",
            value: _vm.loading,
            expression: "loading",
          },
        ],
        ref: "table",
        attrs: {
          data: _vm.tableData,
          selectable: _vm.handleCheck,
          columns: _vm.columns,
          pagination: false,
        },
        on: {
          "selection-change": _vm.handleSelectionChange,
          "page-change": _vm.getListData,
        },
        scopedSlots: _vm._u([
          {
            key: "shopName",
            fn: function (ref) {
              var row = ref.row
              return [
                _c(
                  "p",
                  { staticClass: "oneline", attrs: { title: row.shopName } },
                  [_vm._v(_vm._s(_vm.$dataCheck(row.shopName)))]
                ),
              ]
            },
          },
          {
            key: "subject",
            fn: function (ref) {
              var row = ref.row
              return [
                _c(
                  "p",
                  { staticClass: "oneline", attrs: { title: row.subject } },
                  [_vm._v(_vm._s(_vm.$dataCheck(row.subject)))]
                ),
              ]
            },
          },
          {
            key: "fromHeader",
            fn: function () {
              return [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.$t("after-sales::in-box::in_out_mail_send_email")
                    ) +
                    " "
                ),
                _c(
                  "el-tooltip",
                  {
                    staticClass: "item",
                    attrs: { effect: "dark", placement: "top-start" },
                  },
                  [
                    _c("div", { attrs: { slot: "content" }, slot: "content" }, [
                      _c("div", [
                        _c("span", { staticClass: "dot" }),
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t(
                                "after-sales::in-box::in_out_mail_user_send"
                              )
                            ) +
                            " "
                        ),
                      ]),
                      _c("div", [
                        _c("span", { staticClass: "dot cus" }),
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t(
                                "after-sales::in-box::in_out_mail_customer_send"
                              )
                            ) +
                            " "
                        ),
                      ]),
                    ]),
                    _c("i", { staticClass: "el-icon-question" }),
                  ]
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "from",
            fn: function (ref) {
              var row = ref.row
              return [
                _c("div", [
                  row.type === 2
                    ? _c("div", [
                        _c("span", { staticClass: "dot" }),
                        _vm._v(" " + _vm._s(_vm.$dataCheck(row.from)) + " "),
                      ])
                    : row.type === 1
                    ? _c("div", [
                        _c("span", { staticClass: "dot cus" }),
                        _vm._v(" " + _vm._s(_vm.$dataCheck(row.from)) + " "),
                      ])
                    : _vm._e(),
                ]),
              ]
            },
          },
          {
            key: "sentDate",
            fn: function (ref) {
              var row = ref.row
              return [_c("p", [_vm._v(_vm._s(_vm.$dataCheck(row.sentDate)))])]
            },
          },
          {
            key: "tagList",
            fn: function (ref) {
              var row = ref.row
              return [
                row.tagList && row.tagList.length
                  ? _vm._l(row.tagList, function (tag, i) {
                      return _c(
                        "el-tag",
                        {
                          key: i,
                          staticClass: "tag-cell-item",
                          style:
                            "background-color: " +
                            tag.color +
                            ";\n            border-color: " +
                            tag.color +
                            ";\n            color: #fff;margin-right: 4px;margin-bottom: 4px;",
                          attrs: {
                            size: "small",
                            closable: "",
                            title: tag.allName,
                          },
                          on: {
                            close: function ($event) {
                              return _vm.handleCloseTags(row, tag.id)
                            },
                          },
                        },
                        [_vm._v(" " + _vm._s(tag.allName) + " ")]
                      )
                    })
                  : _c("span", [_vm._v("--")]),
              ]
            },
          },
          {
            key: "operate",
            fn: function (ref) {
              var row = ref.row
              return [
                _c(
                  "el-button",
                  {
                    attrs: { type: "text" },
                    on: {
                      click: function ($event) {
                        return _vm.handleTo(row)
                      },
                    },
                  },
                  [
                    _vm._v(
                      _vm._s(_vm.$t("after-sales::in-box::in_out_mail_detail"))
                    ),
                  ]
                ),
                row.type === 1
                  ? _c(
                      "el-button",
                      {
                        attrs: { type: "text" },
                        on: {
                          click: function ($event) {
                            return _vm.handleBtn("back", row)
                          },
                        },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t("after-sales::in-box::in_out_mail_reply")
                            ) +
                            " "
                        ),
                      ]
                    )
                  : _vm._e(),
              ]
            },
          },
        ]),
      }),
      _c("drawerEmail", {
        attrs: { drawRow: _vm.drawRow },
        model: {
          value: _vm.drawerVisable,
          callback: function ($$v) {
            _vm.drawerVisable = $$v
          },
          expression: "drawerVisable",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }